
























































import Vue from "vue";

// Vue components
import EditOrganizationDialog from "./EditOrganizationDialog.vue";
import ProfilesTable from "@/views/App/Tools/UserManagement/ProfilesTable.vue";
import UsersTable from "@/views/App/Tools/UserManagement/UsersTable.vue";

// Model
import { Organization } from "@/model/data/organizations/Organization";
import { ADLegacyParams, AzureADParams, LoginMode, LoginModeType, loginModeTypeEnumLabel } from "@/model/data/organizations/LoginMode";

export default Vue.extend({
    components: {
        EditOrganizationDialog,
        ProfilesTable,
        UsersTable,
    },
    data() {
        return {
            LoginModeType,
            showEditOrganizationDialog: false,
            newADLegacyParams: null,
            newAzureADParams: null,
            newLoginModes: [],
        };
    },
    props: {
        organization: { type: Object as () => Organization, required: true },
    },
    watch: {
        organization(newValue) {
            this.reset();
        },
    },
    methods: {
        loginModeTypeEnumLabel,

        reset() {
            this.showEditOrganizationDialog = false;

            this.newLoginModes = [];
            Object.keys(LoginModeType)
                .filter((v) => isNaN(Number(v)))
                .forEach((element) => {
                    var tempLoginMode = new LoginMode();
                    tempLoginMode.type = LoginModeType[element];
                    tempLoginMode.enabled = false;
                    tempLoginMode.params = null;
                    this.newLoginModes.push(tempLoginMode);
                });

            this.newADLegacyParams = new ADLegacyParams();
            this.newAzureADParams = new AzureADParams();

            // console.log("this.organization.loginModes", this.organization.loginModes);
            // console.log("this.newLoginModes", this.newLoginModes);

            if (this.organization.loginModes != null)
                this.organization.loginModes.forEach((loginMode: LoginMode) => {
                    if (this.newLoginModes.some((l) => l.type == loginMode.type)) {
                        this.newLoginModes.filter((l) => l.type == loginMode.type)[0].enabled = loginMode.enabled;
                        if (loginMode.params != null) {
                            try {
                                switch (loginMode.type) {
                                    case LoginModeType.ADLegacy:
                                        this.newADLegacyParams = JSON.parse(loginMode.params);
                                        break;
                                    case LoginModeType.AzureAD:
                                        this.newAzureADParams = JSON.parse(loginMode.params);
                                        break;
                                    default:
                                        break;
                                }
                            } catch (error) {
                                console.error("Error parsing these loginMode params: ", loginMode);
                            }
                        }
                    }
                });
        },

        onClosingEditOrganizationDialog() {
            this.showEditOrganizationDialog = false;
            this.$emit("getOrganizations");
        },

        filterUsersTable(profileName: string) {
            this.$refs.usersTable.filterUsersTable(profileName);
        },
    },
    mounted() {
        this.reset();
    },
});
